var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "45",
        height: "45",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M4 5C3.46957 5 2.96086 5.21071 2.58579 5.58579C2.21071 5.96086 2 6.46957 2 7C2.00028 7.35081 2.09282 7.69537 2.26834 7.9991C2.44387 8.30284 2.69619 8.55507 3 8.73047V21.2715C2.69648 21.4467 2.44434 21.6986 2.26883 22.002C2.09333 22.3054 2.00062 22.6495 2 23C2 23.5304 2.21071 24.0391 2.58579 24.4142C2.96086 24.7893 3.46957 25 4 25C4.35081 24.9997 4.69537 24.9072 4.9991 24.7317C5.30284 24.5561 5.55507 24.3038 5.73047 24H24.2715C24.4467 24.3035 24.6986 24.5557 25.002 24.7312C25.3054 24.9067 25.6495 24.9994 26 25C26.5304 25 27.0391 24.7893 27.4142 24.4142C27.7893 24.0391 28 23.5304 28 23C27.9997 22.6492 27.9072 22.3046 27.7317 22.0009C27.5561 21.6972 27.3038 21.4449 27 21.2695V8.72852C27.3035 8.55328 27.5557 8.30136 27.7312 7.998C27.9067 7.69463 27.9994 7.35047 28 7C28 6.46957 27.7893 5.96086 27.4142 5.58579C27.0391 5.21071 26.5304 5 26 5C25.6492 5.00028 25.3046 5.09282 25.0009 5.26834C24.6972 5.44387 24.4449 5.69619 24.2695 6H5.72852C5.55328 5.69648 5.30136 5.44434 4.998 5.26883C4.69463 5.09333 4.35047 5.00062 4 5ZM5.73047 8H24.2715C24.4463 8.30301 24.6975 8.55488 25 8.73047V21.2715C24.697 21.4463 24.4451 21.6975 24.2695 22H5.72852C5.55374 21.697 5.30254 21.4451 5 21.2695V8.72852C5.30301 8.55374 5.55488 8.30254 5.73047 8Z",
          fill: "currentColor"
        }
      }),
      _vm._v(" "),
      _c("mask", { attrs: { id: "path-2-inside-1", fill: "white" } }, [
        _c("rect", {
          attrs: { x: "11", y: "12", width: "13", height: "9", rx: "1" }
        })
      ]),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "11",
          y: "12",
          width: "13",
          height: "9",
          rx: "1",
          stroke: "currentColor",
          "stroke-width": "4",
          mask: "url(#path-2-inside-1)"
        }
      }),
      _vm._v(" "),
      _c("mask", { attrs: { id: "path-3-inside-2", fill: "white" } }, [
        _c("rect", {
          attrs: { x: "6", y: "9", width: "13", height: "9", rx: "1" }
        })
      ]),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "6",
          y: "9",
          width: "13",
          height: "9",
          rx: "1",
          fill: "white",
          stroke: "currentColor",
          "stroke-width": "4",
          mask: "url(#path-3-inside-2)"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }